/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
 <template>
  <div>
    <b-form>
      <div class="row">
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Nome Comum:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="praga.nome_comum"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Nome Científico:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="praga.nome_cientifico"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Siagro:" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="praga.siagro"
              type="number"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Siagro 2:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="praga.siagro_2"
              type="number"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Grupo Alvo" label-for>
            <v-select
              label="nome"
              :options="grupos_alvo"
              :reduce="(item) => item.id_grupo_alvo"
              v-model="praga.id_grupo_alvo"
            >
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Código SIGA:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="praga.cod_siga"
              type="number"
              required
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <b-button type="submit" variant="success" @click.prevent="salvar"
        >Salvar</b-button
      >
    </b-form>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </div>
</template>
<script>
import Service from '@src/services/pragas'
import { mask } from 'vue-the-mask'
import Loading from 'vue-loading-overlay'

import GruposAlvo from '@src/services/grupo-alvo'

export default {
  components: {
    Loading,
  },
  directives: { mask },
  props: {
    praga: {},
  },
  data() {
    return {
      grupos_alvo: [],
      modal: {
        show: false,
        mensagems: null,
        sucesso: null,
      },
      isLoading: false,
    }
  },
  created() {},
  mounted() {
    console.log(this.praga)
    this.handleGet()
  },
  methods: {
    loading(a) {
      a = !this.isLoading
      return a
    },
    modalShow() {
      if (this.modal.show === true) {
        this.modal.show = false
      }
    },
    handleGet() {
      const token = this.$store.state.auth.currentUser.token
      GruposAlvo.listar(token).then((response) => {
        this.grupos_alvo = response.data.dados
      })
    },
    salvar() {
      const token = this.$store.state.auth.currentUser.token
      if (this.praga.id_pragas) {
        this.isLoading = this.loading(this.isLoading)
        Service.update(token, this.praga)
          .then((resposta) => {
            this.modal.show = true
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.modal.mensagems = resposta.data.aviso
            this.isLoading = this.loading(this.isLoading)
          })
          .catch((erro) => {
            this.$bvToast.toast(erro.response.data.data.join(', '), {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(false)
          })
      } else {
        this.isLoading = this.loading(this.isLoading)
        Service.salvar(token, this.praga)
          .then((resposta) => {
            this.isLoading = this.loading(this.isLoading)
            if (!resposta.data.sucesso) {
              this.$bvToast.toast(resposta.data.mensagem, {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            } else {
              this.$bvToast.toast('Salvo com sucesso!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            }
            this.praga = {}
          })
          .catch((erro) => {
            console.log(erro)
            this.isLoading = this.loading(this.isLoading)
            this.$bvToast.toast(
              erro.response ? erro.response.data.data : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
            this.isLoading = this.loading(false)
          })
      }
    },
  },
}
</script>

<style>
</style>